<template>
  <div>
  <div class="d-none d-sm-block">
      <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Übersicht</router-link> </li>
        <li class="breadcrumb-item"><router-link to="/BenutzerList">Benutzer</router-link> </li>
        <li class="breadcrumb-item active" aria-current="page">bearbeiten</li>
      </ol>
    </nav>
 </div>
    <b-alert :show="loading" variant="info">Loading...</b-alert>

    <Profil v-if="user!=null" ref="Profil" @userchanged="userChanged" :user="user" :profil="false"/>

  </div>
</template>

<script>
import Profil from './Profil.vue'

import api from '@/api/benutzer'

export default {
  name: 'Benutzer',
  components: {
    Profil
  },
  data () {
    return {
      user: {},
      loading: false
    }
  },
  beforeMount () {
    this.refresh()
  },
  watch: {
    '$route.params': {
      handler (newValue) {
        this.update()
      }
    }
  },
  methods: {
    userChanged: function (user) {
      console.log('set user')
      if (user != null) {
        this.user = user
      }
    },
    async update () {
      this.loading = true
      this.user = await api.get(this.$route.params.id)
      this.loading = false
    },
    async refresh () {
      this.update()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/Benutzer.vue